import styled from 'styled-components';
import { SpaceProps } from 'styled-system';
import Grid from '../../layoutComponents/Grid';
import Box from '../../layoutComponents/Box';

export type BaseStyleProps = SpaceProps;

export const CheckboxGroupWrapper = styled(Box)``;

export default styled(Grid)(
  ({ theme, disabled }) => `
  ${disabled &&
    `
    input, label {
      cursor: not-allowed;
      color: ${theme.colors.grayScale[5]};
    }
  `}
`
);
